import { createTheme } from "@mui/material/styles";
import { blue, green, grey, orange, red } from "@mui/material/colors";

// @TODO Update: - esse arquivo se espalha por todo código, isso é ruim
//               - colors.primary != theme.palette.primary.*

const colors = {
  // TODO: REMOVER AS REFERÊNCIAS DESSE CAMPOS.
  primary: blue[500],
  primaryDark: blue[600],
  secondary: red[500],
  secondaryDark: red[600],

  success: green[500],
  successDark: green[600],
  danger: red[500],
  dangerDark: red[600],
  warning: orange[500],
  warningDark: orange[600],
  grey: grey[300],
  greyDark: grey[500],
  contrast: "#FB8C00",
  contrastDark: orange[800],
  typography: "#607D8B",
  blueDark: "#197997",
  blueDark2: "#1F8CAD",
  blueGray: "#263245",
  blueLight: "#09AFDF",
  blueLight2: "#2BADD3",
  veryDarkBlue: "#004A61",
  blueDark3: "#0C6F8D",
};

// `theme.breakpoints` precisa estar disponível pra uso dentro dos
// callbacks de `styleOverrides` abaixo.
const breakpoints = createTheme().breakpoints;

// Theme MUI v5 nativo (API com `components: { MuiX: { styleOverrides: {} } }`)
// — substitui o antigo `overrides: { MuiX: {} }` do v4 sem `adaptV4Theme`.
const theme = createTheme({
  palette: {
    primary: {
      main: "#0080ad",
      light: "#09AFDF",
      dark: "#197997",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: red[500],
      contrastText: "#FFFFFF",
    },
    text: {
      primary: "rgba(96, 125, 139)",
      secondary: "rgba(96, 125, 139, 0.80)",
      disabled: "rgb(176, 190, 197)",
    },
  },
  typography: {
    fontFamily: '"Montserrat"',
    letterSpacing: "0",
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        body1: { fontSize: "0.875rem" },
        // Quando o componente usa `color="inherit"` (ex: título do navbar
        // sobre AppBar primary), não força o cinza — deixa herdar do pai.
        root: ({ ownerState }) => ({
          letterSpacing: "0",
          ...(ownerState?.color === "inherit"
            ? {}
            : { color: "#607D8B" }),
        }),
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: { padding: "0px 24px" },
        expandIconWrapper: { padding: "0px 8px" },
      },
    },
    MuiAccordionActions: {
      styleOverrides: {
        root: { padding: "16px 8px" },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: { padding: "8px 24px 24px" },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        // root NÃO força padding fixo — em v5 isso sobrescreve `padding="none"`
        // (usado pela coluna de indicador de status com width=8px). Só aplica o
        // padding padrão quando `ownerState.padding === 'normal'` (default).
        root: ({ ownerState }) => ({
          fontSize: "0.86rem",
          color: "#1a3a47",
          fontWeight: 450,
          letterSpacing: "-0.1px",
          ...(ownerState?.padding === "normal" && {
            padding: "14px 24px",
          }),
        }),
        paddingCheckbox: {
          width: "auto",
          padding: "0 12px",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          height: "auto",
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        selectLabel: { fontSize: "0.75rem" },
        displayedRows: { fontSize: "0.75rem" },
        input: { fontSize: "0.75rem" },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: { paddingTop: "11px", paddingBottom: "11px" },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: { padding: "0 16px", marginTop: "0px", marginBottom: "0px" },
        multiline: { marginTop: "0px", marginBottom: "0px" },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: { minWidth: "auto", marginRight: "16px" },
      },
    },
    MuiListItemAvatar: {
      styleOverrides: {
        root: { minWidth: "auto" },
      },
    },
    MuiPaper: {
      styleOverrides: {
        // Em v5, `elevation1` virou via prop `elevation={1}` sem override
        // direto. Aplicamos o box-shadow no root quando elevation=1.
        root: ({ ownerState }) =>
          ownerState?.elevation === 1
            ? {
                boxShadow:
                  " 0px 0.5px 5px 0px rgba(0,0,0,0.2)," +
                  " 0px 0.5px 2px 0px rgba(0,0,0,0.14)," +
                  " 0px 1px 1px -2px rgba(0,0,0,0.12)",
              }
            : {},
      },
    },
    MuiDialog: {
      styleOverrides: {
        paperScrollBody: { verticalAlign: "top" },
        paper: { margin: "64px" },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: { overflowY: "initial", padding: "0px 24px 24px" },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: { display: "flex" },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: { fontSize: "1.5rem" },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        sizeSmall: { padding: "auto" },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: "0.8125rem",
          [breakpoints.up("md")]: { padding: "6px 24px" },
          [breakpoints.down("md")]: { padding: "6px 12px" },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: { paddingTop: "11px", paddingBottom: "11px" },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: { display: "flex" },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: { fontSize: ".8rem" },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: { margin: "16px 0px 0px !important" },
      },
    },
  },
});

export { theme, colors };
